import { render, staticRenderFns } from "./mutiIndex.vue?vue&type=template&id=1382de90&scoped=true"
import script from "./mutiIndex.vue?vue&type=script&lang=js"
export * from "./mutiIndex.vue?vue&type=script&lang=js"
import style0 from "./mutiIndex.vue?vue&type=style&index=0&id=1382de90&prod&lang=stylus&scoped=true"
import style1 from "./mutiIndex.vue?vue&type=style&index=1&id=1382de90&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1382de90",
  null
  
)

export default component.exports